import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Typography,
  Divider
} from '@material-ui/core';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: 8,
    width: 640,
    maxWidth: 760,
    minWidth: 420,
    background: '#FFFFFF',
    boxShadow: '0px 8px 40px rgba(0,0,0,0.12)',
    paddingTop: 8,
    paddingBottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
    boxSizing: 'border-box',
    border: '3px solid #8E24AA',
    marginTop: '44vh', // Position dialog lower on the screen
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 12,
    paddingBottom: 12
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  warningIcon: {
    color: '#8E24AA',
    fontSize: 28,
    flexShrink: 0,
    background: '#F3E5F5',
    borderRadius: 6,
    padding: 6,
    boxSizing: 'content-box'
  },
  titleText: {
    fontWeight: 700,
    fontSize: 20,
    color: '#111111'
  },
  closeButton: {
    padding: 6,
    marginLeft: 8,
    color: '#757575',
    '&:hover': {
      color: '#000000'
    }
  },
  subheader: {
    fontWeight: 600,
    fontSize: 15,
    color: '#1E1450',
    marginBottom: 6,
    lineHeight: 1.4
  },
  bodyText: {
    color: '#666666',
    fontSize: 14,
    marginTop: 0,
    lineHeight: 1.4,
    maxWidth: 520
  },
  actions: {
    paddingTop: 18,
    paddingBottom: 18,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
    background: '#FFFFFF'
  },
  cancelButton: {
    textTransform: 'none',
    borderRadius: 24,
    padding: '8px 20px',
    border: '1px solid #C4C4C4',
    color: '#333333',
    backgroundColor: '#FFFFFF',
    fontWeight: 500,
    fontSize: 14,
    minWidth: 100,
    height: 36,
    '&:hover': {
      backgroundColor: '#F5F5F5'
    }
  },
  deleteButton: {
    backgroundColor: '#00445D',
    color: '#FFFFFF',
    borderRadius: 24,
    textTransform: 'none',
    padding: '10px 28px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
    fontWeight: 600,
    fontSize: 14,
    minWidth: 120,
    height: 40,
    '&:hover': { backgroundColor: '#00374C' }
  },
  dialogContainer: {
    alignItems: 'flex-start', // Align to top instead of center
  }
}));

export default function DeleteFolderDialog({ open, onClose, onConfirm, folderId }) {
  const classes = useStyles();

  const handleConfirm = () => {
    if (typeof onConfirm === 'function') onConfirm(folderId);
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      aria-labelledby="delete-folder-dialog"
      PaperProps={{ className: classes.paper }}
      BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.45)' } }}
      transitionDuration={200}
      maxWidth="xs"
      fullWidth={false}
      classes={{ container: classes.dialogContainer }}
    >
      <Box className={classes.header}>
        <Box className={classes.titleRow}>
          <WarningOutlinedIcon className={classes.warningIcon} />
          <Typography className={classes.titleText}>Delete Folder</Typography>
        </Box>
        <IconButton className={classes.closeButton} onClick={onClose} aria-label="close">
          <CloseIcon style={{ fontSize: 20 }} />
        </IconButton>
      </Box>

  <Divider style={{ borderBottom: '1px solid #E0E0E0', marginTop: 8, marginBottom: 12 }} />

  <DialogContent style={{ paddingTop: 12, paddingBottom: 12 }}>
        <Typography className={classes.subheader}>Confirm Deletion</Typography>
        <Typography className={classes.bodyText}>
          The folder will be permanently deleted. This action cannot be undone.
        </Typography>
      </DialogContent>

      <Divider style={{ borderBottom: '1px solid #E0E0E0', marginTop: 12, marginBottom: 0 }} />

      <DialogActions className={classes.actions} style={{ paddingTop: 12, paddingBottom: 12 }}>
        <div style={{ flex: 1 }} />
        <Button onClick={onClose} variant="outlined" className={classes.cancelButton}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" className={classes.deleteButton}>Yes, Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
